export function getRoom(roomId) {
    return abp.ajax({
        url: '/api/services/app/Project/GetRoomById',
        method: 'get',
        params: { id: roomId }
    });
}
